const cv_lite_slugs = (t) => {
  return {
    'landing.title': t('cvlite_landing'),
    'landing.description': t('cvlite_landing.description'),
    'landing.list_item_1': t('cvlite_landing.list_item1'),
    'landing.list_item_2': t('cvlite_landing.list_item2'),
    'landing.list_item_3': t('cvlite_landing.list_item3'),
    resume_nation_landing_s1_p1: t('cvlite_landing_s1_p1'),
    resume_nation_landing_s1_p3: t('cv_lite_landing_s1_p3'),
    resume_nation_landing_asset_2: t('resume_nation_landing_asset_2'),
    resume_nation_landing_s2_p1: t('cv_lite_landing_s2_p1'),
    resume_nation_landing_s2_p2: t('cv_lite_landing_s2_p2'),
    resume_nation_landing_s3_p1: t('cv_lite_landing_s3_p1'),
    resume_nation_landing_s3_p2: t('cv_lite_landing_s3_p2'),
    resume_nation_landing_s3_p3: t('cv_lite_landing_s3_p3'),
    resume_nation_landing_s3_p4: t('cv_lite_landing_s3_p4'),
    resume_nation_landing_s3_p5: t('cv_lite_landing_s3_p5'),
    resume_nation_landing_s3_p6: t('cv_lite_landing_s3_p6'),
    resume_nation_landing_s3_p7: t('cv_lite_landing_s3_p7'),
    resume_nation_landing_s3_p8: t('cv_lite_landing_s3_p8'),
    resume_nation_landing_s4_p1: t('cv_lite_landing_s4_p1'),
    resume_nation_landing_s4_p2: t('cv_lite_landing_s4_p2'),
    resume_nation_landing_s5_p1: t('cv_lite_landing_s5_p1'),
    resume_nation_landing_s5_p2: t('cv_lite_landing_s5_p2'),
    resume_nation_landing_s5_p3: t('cv_lite_landing_s5_p3'),
    resume_nation_landing_s5_p4: t('cv_lite_landing_s5_p4'),
    resume_nation_landing_s5_p5: t('cv_lite_landing_s5_p5'),
    resume_nation_landing_s5_p6: t('cv_lite_landing_s5_p6'),
    resume_nation_landing_s5_p7: t('cv_lite_landing_s5_p7'),
    resume_nation_landing_s5_p8: t('cv_lite_landing_s5_p8'),
    resume_nation_landing_s5_p9: t('cv_lite_landing_s5_p9'),
    resume_nation_landing_s5_p10: t('cv_lite_landing_s5_p10'),
    resume_nation_landing_s5_p11: t('cv_lite_landing_s5_p11'),
    resume_nation_landing_s5_p12: t('cv_lite_landing_s5_p12'),
    resume_nation_landing_s5_p13: t('cv_lite_landing_s5_p13'),
    resume_nation_landing_s5_p14: t('cv_lite_landing_s5_p14'),
    resume_nation_landing_s5_p15: t('cv_lite_landing_s5_p15'),
    resume_nation_landing_s5_p16: t('cv_lite_landing_s5_p16'),
    resume_nation_landing_s5_p17: t('cv_lite_landing_s5_p17'),
    resume_nation_landing_s5_p18: t('cv_lite_landing_s5_p18'),
    resume_nation_landing_s5_p19: t('cv_lite_landing_s5_p19'),
    resume_nation_landing_s5_p20: t('cv_lite_landing_s5_p20'),
    resume_nation_landing_s5_p21: t('cv_lite_landing_s5_p21'),
    resume_nation_landing_s5_p22: t('cv_lite_landing_s5_p22'),
    resume_nation_landing_s6_p1: t('cv_lite_landing_s6_p1'),
    resume_nation_landing_s6_p2: t('cv_lite_landing_s6_p2'),
  };
};

const default_slugs = (t) => {
  return {
    'landing.title': t('landing.title'),
    'landing.description': t('landing.description'),
    'landing.list_item_1': t('landing.list_item_1'),
    'landing.list_item_2': t('landing.list_item_2'),
    'landing.list_item_3': t('landing.list_item_3'),
    resume_nation_landing_s1_p1: t('resume_nation_landing_s1_p1'),
    resume_nation_landing_s1_p2: t('resume_nation_landing_s1_p2'),
    resume_nation_landing_s1_p3: t('resume_nation_landing_s1_p3'),
    resume_nation_landing_asset_2: t('resume_nation_landing_asset_2'),
    resume_nation_landing_s2_p1: t('resume_nation_landing_s2_p1'),
    resume_nation_landing_s2_p2: t('resume_nation_landing_s2_p2'),
    resume_nation_landing_s3_p1: t('resume_nation_landing_s3_p1'),
    resume_nation_landing_s3_p2: t('resume_nation_landing_s3_p2'),
    resume_nation_landing_s3_p3: t('resume_nation_landing_s3_p3'),
    resume_nation_landing_s3_p4: t('resume_nation_landing_s3_p4'),
    resume_nation_landing_s3_p5: t('resume_nation_landing_s3_p5'),
    resume_nation_landing_s3_p6: t('resume_nation_landing_s3_p6'),
    resume_nation_landing_s3_p7: t('resume_nation_landing_s3_p7'),
    resume_nation_landing_s3_p8: t('resume_nation_landing_s3_p8'),
    resume_nation_landing_s4_p1: t('resume_nation_landing_s4_p1'),
    resume_nation_landing_s4_p2: t('resume_nation_landing_s4_p2'),
    resume_nation_landing_s5_p1: t('resume_nation_landing_s5_p1'),
    resume_nation_landing_s5_p2: t('resume_nation_landing_s5_p2'),
    resume_nation_landing_s5_p3: t('resume_nation_landing_s5_p3'),
    resume_nation_landing_s5_p4: t('resume_nation_landing_s5_p4'),
    resume_nation_landing_s5_p5: t('resume_nation_landing_s5_p5'),
    resume_nation_landing_s5_p6: t('resume_nation_landing_s5_p6'),
    resume_nation_landing_s5_p7: t('resume_nation_landing_s5_p7'),
    resume_nation_landing_s5_p8: t('resume_nation_landing_s5_p8'),
    resume_nation_landing_s5_p9: t('resume_nation_landing_s5_p9'),
    resume_nation_landing_s5_p10: t('resume_nation_landing_s5_p10'),
    resume_nation_landing_s5_p11: t('resume_nation_landing_s5_p11'),
    resume_nation_landing_s5_p12: t('resume_nation_landing_s5_p12'),
    resume_nation_landing_s5_p13: t('resume_nation_landing_s5_p13'),
    resume_nation_landing_s5_p14: t('resume_nation_landing_s5_p14'),
    resume_nation_landing_s5_p15: t('resume_nation_landing_s5_p15'),
    resume_nation_landing_s5_p16: t('resume_nation_landing_s5_p16'),
    resume_nation_landing_s5_p17: t('resume_nation_landing_s5_p17'),
    resume_nation_landing_s5_p18: t('resume_nation_landing_s5_p18'),
    resume_nation_landing_s5_p19: t('resume_nation_landing_s5_p19'),
    resume_nation_landing_s5_p20: t('resume_nation_landing_s5_p20'),
    resume_nation_landing_s5_p21: t('resume_nation_landing_s5_p21'),
    resume_nation_landing_s5_p22: t('resume_nation_landing_s5_p22'),
    resume_nation_landing_s6_p1: t('resume_nation_landing_s6_p1'),
    resume_nation_landing_s6_p2: t('resume_nation_landing_s6_p2'),
  };
};

const cvtoolspro_slugs = (t) => {
  return {
    'landing.title': t('cvtoolspro_landing'),
    'landing.description': t('cvtoolspro_description'),
    'landing.list_item_1': t('cvtoolspro.list_item_1'),
    'landing.list_item_2': t('cvtoolspro.list_item_2'),
    'landing.list_item_3': t('cvtoolspro.list_item_3'),
    resume_nation_landing_s1_p1: t('cvtoolspro_s1_p1'),
    resume_nation_landing_s1_p2: t('cvtoolspro_s1_p2'),
    resume_nation_landing_s1_p3: t('cvtoolspro_s1_p3'),
    resume_nation_landing_asset_2: t('resume_nation_landing_asset_2'),
    resume_nation_landing_s2_p1: t('cvtoolspro_s2_p1'),
    resume_nation_landing_s2_p2: t('cvtoolspro_s2_p2'),
    resume_nation_landing_s3_p1: t('cvtoolspro_s3_p1'),
    resume_nation_landing_s3_p2: t('cvtoolspro_s3_p2'),
    resume_nation_landing_s3_p3: t('cvtoolspro_s3_p3'),
    resume_nation_landing_s3_p4: t('cvtoolspro_s3_p4'),
    resume_nation_landing_s3_p5: t('cvtoolspro_s3_p5'),
    resume_nation_landing_s3_p6: t('cvtoolspro_s3_p6'),
    resume_nation_landing_s3_p7: t('cvtoolspro_s3_p7'),
    resume_nation_landing_s3_p8: t('cvtoolspro_s3_p8'),
    resume_nation_landing_s4_p1: t('cvtoolspro_s4_p1'),
    resume_nation_landing_s4_p2: t('cvtoolspro_s4_p2'),
    resume_nation_landing_s5_p1: t('cvtoolspro_s5_p1'),
    resume_nation_landing_s5_p2: t('cvtoolspro_s5_p2'),
    resume_nation_landing_s5_p3: t('cvtoolspro_s5_p3'),
    resume_nation_landing_s5_p4: t('cvtoolspro_s5_p4'),
    resume_nation_landing_s5_p5: t('cvtoolspro_s5_p5'),
    resume_nation_landing_s5_p6: t('cvtoolspro_s5_p6'),
    resume_nation_landing_s5_p7: t('cvtoolspro_s5_p7'),
    resume_nation_landing_s5_p8: t('cvtoolspro_s5_p8'),
    resume_nation_landing_s5_p9: t('cvtoolspro_s5_p9'),
    resume_nation_landing_s5_p10: t('cvtoolspro_s5_p10'),
    resume_nation_landing_s5_p11: t('cvtoolspro_s5_p11'),
    resume_nation_landing_s5_p12: t('cvtoolspro_s5_p12'),
    resume_nation_landing_s5_p13: t('cvtoolspro_s5_p13'),
    resume_nation_landing_s5_p14: t('cvtoolspro_s5_p14'),
    resume_nation_landing_s5_p15: t('cvtoolspro_s5_p15'),
    resume_nation_landing_s5_p16: t('cvtoolspro_s5_p16'),
    resume_nation_landing_s5_p17: t('cvtoolspro_s5_p17'),
    resume_nation_landing_s5_p18: t('cvtoolspro_s5_p18'),
    resume_nation_landing_s5_p19: t('cvtoolspro_s5_p19'),
    resume_nation_landing_s5_p20: t('cvtoolspro_s5_p20'),
    resume_nation_landing_s5_p21: t('cvtoolspro_s5_p21'),
    resume_nation_landing_s5_p22: t('cvtoolspro_s5_p22'),
    resume_nation_landing_s6_p1: t('cvtoolspro_s6_p1'),
    resume_nation_landing_s6_p2: t('cvtoolspro_s6_p2'),
  };
};

export const content_landing_slugs = (host, t) => {
  switch (host) {
    case 'cv-lite':
      return cv_lite_slugs(t);
    case 'cvtoolspro':
      return cvtoolspro_slugs(t);
    default:
      return default_slugs(t);
  }
};

export const getTotalReviewCount = (host) => {
  switch (host) {
    case 'cv-lite':
      return '4,7 out of 5,488 Reviews';
    case 'cvtoolspro':
      return '4.3 out of 1,048 Reviews';
  }
};

export const getReviewByHost = (host) => {
  const hostData = {
    'cv-lite': {
      cardLine1: [
        {
          title: 'Helpful resume maker',
          subTitle:
            'With the help of AI suggestions I got the perfect resume and my resume has been very noticeable ever since.',
          isPhoto: true,
          name: 'Diana Joseph',
          countryName: '🇦🇪 UAE',
          imgUrl: 'trustpilotuser4.png',
        },
        {
          title: 'simple and clear',
          subTitle: 'clear, practical, easy to use',
          isPhoto: false,
          name: 'Fabrice Denimal',
          countryName: '🇫🇷 France',
        },
        {
          title: 'I love it!',
          subTitle: 'Perfect for creating a clean, fancy and professional CV!',
          isPhoto: true,
          name: 'Monara Kaelle',
          countryName: '🇺🇸 United States',
          imgUrl: 'trustpilotuser1.png',
        },
        {
          title: 'best website for cv templates',
          subTitle: 'great template',
          isPhoto: false,
          name: 'Lozenka Gorgieva',
          countryName: 'Milton Keynes',
        },
      ],
      cardLine2: [
        {
          title: 'Perfect program ti have a perfect CV',
          subTitle: 'Perfect program ti have a perfect CV',
          isPhoto: false,
          name: 'Laura',
          countryName: '🇮🇹 Italy',
        },
        {
          title: 'Top-Notch CV Writing Help!',
          subTitle:
            'I had a great experience with this CV writing site. The process was smooth, and the final result exceeded my expectations. The team truly understands how to highlight strengths and tailor the CV to specific roles. I highly recommend this service to anyone looking to enhance their professional profile.',
          isPhoto: false,
          name: 'Kimaya Rathi',
          countryName: '🇸🇬 Singapore',
        },
        {
          title: 'Very good site to create resumes',
          subTitle: 'Very good site to create resumes. Its quite easy to use as well. Definity recommended.',
          isPhoto: true,
          name: 'Snigdha Kanumuri',
          countryName: '🇮🇪 Ireland',
          imgUrl: 'trustpilotuser3.png',
        },
        {
          title: 'Easy to Use',
          subTitle:
            'Quick, Easy to use, and very professional templates. Helped me create a standout resume in minutes. Highly Recommended !',
          isPhoto: true,
          name: 'Irfhan Preena',
          countryName: '🇶🇦 Qatar',
          imgUrl: 'trustpilotuser6.png',
        },
      ],
    },
    cvtoolspro: {
      cardLine1: [
        {
          title: 'I was able to create my cv the way i…',
          subTitle:
            'I was able to create my cv the way i wanted. a number of templates were available to choose from and the best part is that the website is user-friendly.',
          isPhoto: false,
          isBlack: true,
          name: 'Jasmine Dhiman',
          countryName: '🇳🇿 New Zealand',
        },
        {
          title: 'Very good website to make CV.',
          subTitle:
            'Very good website to make CV. <br/> Was very user friendly and did not consume much time to create my CV.',
          isPhoto: true,
          name: 'Tribhuvan Srikanth',
          countryName: '🇦🇪 UAE',
          imgUrl: 'trustpilotuser5.png',
        },
        {
          title: 'Good app to create cv',
          isPhoto: false,
          name: 'Joy Jacklin',
          countryName: '🇮🇱 Israel',
          showNameAs: 'J',
          bgColor: '#EC477E',
          txtColor: '#fff',
        },
        {
          title: 'Excellent',
          subTitle: 'Excellent. Easy to make CV. Thank you very much',
          isPhoto: true,
          name: 'Kazi Sarowar Hossain Bipu',
          countryName: '🇸🇦 Saudi Arabia',
          imgUrl: 'trustpilotuser7.png',
        },
      ],
      cardLine2: [
        {
          title: 'It is very good site for resume building',
          isPhoto: false,
          name: 'Sairam Mavuri',
          countryName: '🇳🇿 New Zealand',
          showNameAs: 'S',
          bgColor: '#5E4037',
          txtColor: '#fff',
        },
        {
          title: 'Its a great website for making Cv and...',
          subTitle:
            'Its a great website for making Cv and reduces the time and effort which one has to otherwise spend on making a professional and high quality CV immensely.',
          isPhoto: false,
          showNameAs: 'S',
          bgColor: '#512Da8',
          txtColor: '#fff',
          name: 'sting bite',
          countryName: '🇸🇦 Saudi Arabia',
        },
        {
          title: 'I was so confuse about how to make a...',
          subTitle:
            'I was so confuse about how to make a professional resume than came across this site that makes it so easy thanks for your work',
          isPhoto: false,
          showNameAs: 'AA',
          bgColor: '#daffe0',
          txtColor: '#000',
          name: 'Aamir',
          countryName: '🇦🇪 UAE',
        },
        {
          title: 'resume creation',
          subTitle:
            'This website is mainly used for resume creation. Now a days very difficult to create a wonderful resume but we can easily create extraordinary resume through this web site.',
          isPhoto: false,
          showNameAs: 'AM',
          bgColor: '#ffdde8',
          txtColor: '#1c1c22',
          name: 'Amar',
          countryName: '🇦🇪 UAE',
        },
      ],
    },
  };
  return hostData[host];
};
